import { Swiper } from 'swiper';
import {Navigation, Autoplay, EffectFade, Pagination} from "swiper/modules";
Swiper.use([Navigation, Autoplay, EffectFade, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-slider="container"]',
        slider: '[js-slider="slider"]',
        prev: '[js-slider="prev"]',
        next: '[js-slider="next"]',
        pagination: '[js-slider="pagination"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 500,
                effect: "fade",
                fadeEffect: {
                    crossFade: true, // Ensures a smooth crossfade without overlapping
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                },
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                    clickable: true
                },
            });
        })
    }

    return Object.freeze({
        init,
    })
}